import Vue from "vue"
import VueRouter from "vue-router"

Vue.use(VueRouter)

// 精准政策匹配平台 - 路由配置（与 Header 导航一致）
const routes = [
    {
        path: "/",
        name: "landing",
        component: () => import("@/views/Index.vue"),
        meta: { keepAlive: false },
    },
    {
        path: "/policy-files",
        name: "policyFiles",
        component: () => import("@/views/PolicyList.vue"),
        meta: { keepAlive: false, title: "政策文件" },
    },
    {
        path: "/policy-files/:id",
        name: "policyFileDetail",
        component: () => import("@/views/PolicyFileDetail.vue"),
        meta: { keepAlive: false, title: "政策文件详情" },
    },
    {
        path: "/policy-interpretation",
        name: "policyInterpretation",
        component: () => import("@/views/PolicyInterpretation.vue"),
        meta: { keepAlive: false, title: "政策解读" },
    },
    {
        path: "/policy-interpretation/:id",
        name: "policyInterpretationDetail",
        component: () => import("@/views/PolicyDetail.vue"),
        meta: { keepAlive: false, title: "政策解读详情" },
    },
    {
        path: "/result-publicity",
        name: "resultPublicity",
        component: () => import("@/views/ResultPublicity.vue"),
        meta: { keepAlive: false, title: "结果公示" },
    },
    {
        path: "/result-publicity/:id",
        name: "resultPublicityDetail",
        component: () => import("@/views/ResultPublicityDetail.vue"),
        meta: { keepAlive: false, title: "结果公示详情" },
    },
    {
        path: "/declaration-service",
        name: "declarationService",
        component: () => import("@/views/DeclarationService.vue"),
        meta: { keepAlive: false, title: "申报服务" },
    },
    {
        path: "/ai-assistant",
        name: "aiAssistant",
        component: () => import("@/views/AiAssistant.vue"),
        meta: { keepAlive: false, title: "AI助手" },
    },
    {
        path: "/declaration-service/ai",
        name: "declarationAi",
        component: () => import("@/views/DeclarationAiChat.vue"),
        meta: { keepAlive: false, title: "AI 申报助手" },
    },
    {
        path: "/declaration-service/templates",
        name: "declarationTemplates",
        component: () => import("@/views/DeclarationTemplate.vue"),
        meta: { keepAlive: false, title: "申报模版" },
    },
    {
        path: "/match",
        name: "match",
        component: () => import("@/views/Match.vue"),
        meta: { keepAlive: false, title: "精准匹配" },
    },
    {
        path: "/match/enterprise",
        name: "enterpriseProfile",
        component: () => import("@/views/EnterpriseProfile.vue"),
        meta: { keepAlive: false, title: "完善企业信息" },
    },
    {
        path: "/match/enterprise/add",
        name: "enterpriseAdd",
        component: () => import("@/views/EnterpriseProfile.vue"),
        meta: { keepAlive: false, title: "新增企业" },
        props: { addMode: true },
    },
    {
        path: "/user-center",
        name: "userCenter",
        component: () => import("@/views/UserCenter.vue"),
        meta: { keepAlive: false, title: "个人中心" },
    },
    {
        path: "/government-report",
        name: "governmentReport",
        component: () => import("@/views/Placeholder.vue"),
        meta: { keepAlive: false, title: "政府报告" },
    },
    {
        path: "/login",
        name: "login",
        component: () => import("@/views/Login.vue"),
        meta: { keepAlive: false, title: "登录" },
    },
    {
        path: "/register",
        redirect: (to) => ({ path: "/login", query: { ...to.query, mode: "register" } }),
    },
    {
        path: "/forgot-password",
        redirect: (to) => ({ path: "/login", query: { ...to.query, mode: "forgot" } }),
    },

    // 兜底路由：访问未知路径时回到首页
    {
        path: "*",
        redirect: "/",
    },
]

/** 吞掉重复/取消类导航错误，避免 webpack 运行时红屏 */
function ignoreNavError(err) {
    if (
        err &&
        (err.name === 'NavigationDuplicated' ||
            err.name === 'NavigationCancelled' ||
            err.name === 'NavigationRedirected' ||
            (typeof err.message === 'string' &&
                (err.message.includes('Navigation cancelled') ||
                    err.message.includes('Avoided redundant navigation'))))
    ) {
        return err
    }
    return Promise.reject(err)
}

const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace

VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(ignoreNavError)
}

VueRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(ignoreNavError)
}

const router = new VueRouter({
    mode: "history", // 本地/测试环境
    // mode: "hash", // 正式环境时按 README 切换
    // base: "/pc-all/", // 正式环境时按 README 配置
    routes,
    scrollBehavior() {
        return {x: 0, y: 0}
    },
})

export default router
